<div *ngIf="message" class="modal" tabindex="-1" role="dialog" style="display:block!important">
    <div class="modal-dialog custom-alert" role="document">
        <div class="modal-content">
            <div *ngIf="message?.type == 'confirm'" class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-center confirm-message"> {{message.text}} </p>
                    </div>
                </div>
                <div class="row text-center" style="margin-top: 5px;">
                    <button *ngIf="!message.hideBtnOk" (click)="message.siFn()" class="col-5 btn btn-yes"> {{message.btnOkText}} </button>
                    <button *ngIf="!message.hideBtnCancel" (click)="message.noFn()" class="col-5 btn btn-danger btn-no"> {{message.btnCancelText}} </button>
                </div>
            </div>
        </div>
    </div>
</div>